import React, { ReactElement, ReactNode } from "react";

export const recursiveRewriteNode = (
    children: ReactNode,
    fn: (el: ReactElement) => ReactElement,
): ReactNode =>
    React.Children.map(children, child => {
        if (!React.isValidElement(child)) {
            return child;
        }

        if (child.props.children) {
            child = React.cloneElement(
                child,
                undefined,
                recursiveRewriteNode(child.props.children, fn),
            );
        }

        return fn(child);
    });
